import ModelCatalog from "../../components/components-model/ModelCatalog";
import { useDocumentMeta } from "../../hooks/useDocumentMeta";

/**
 * Listado de salas: la misma parrilla que la vitrina, filtrada a "en vivo".
 *
 * Era una segunda pantalla con los mismos filtros, la misma paginación y la
 * misma tarjeta, además de sacar los datos de un endpoint que exponía la clave
 * de emisión de cada modelo. El marco (barra lateral, saldo) lo pone
 * StreamingLayout; el contenido es <ModelCatalog variant="live" />.
 */
export default function LiveList() {
  useDocumentMeta({ title: "Transmisiones en vivo", noIndex: true });

  return <ModelCatalog variant="live" />;
}
